import { createContext, useContext } from 'react'
import type { Owner } from '../api/ownerTypes'

export interface OwnerSession {
  owner: Owner
  signOut: () => Promise<void>
}

export const OwnerContext = createContext<OwnerSession | null>(null)

export function useOwner(): OwnerSession {
  const session = useContext(OwnerContext)

  if (!session) {
    throw new Error('useOwner hoort binnen een <OwnerGate>.')
  }

  return session
}
